package com.wintermar.inspection.core.ui.widget.menu

import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.material3.Icon
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import com.wintermar.inspection.core.ui.component.TextBodyLarge
import com.wintermar.inspection.core.ui.theme.LocalAppTheme
import com.wintermar.inspection.navigation.Route
import com.wintermar.inspection.navigation.toContentModel
import org.jetbrains.compose.resources.painterResource

@Composable
fun TopBarItem(
    route: Route,
    onClick: (Route) -> Unit
) {
    val dimension = LocalAppTheme.current.dimension
    val content = route.toContentModel()

    if (content != null) {
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .clickable {
                    onClick(route)
                }
                .padding(
                    horizontal = dimension.spacing.space5,
                    vertical = dimension.spacing.space4
                ),
            horizontalArrangement = Arrangement.spacedBy(
                dimension.spacing.space3
            ),
            verticalAlignment = Alignment.CenterVertically
        ) {
            Icon(
                painter = painterResource(content.resIcon),
                tint = content.tint,
                modifier = Modifier.size(dimension.size.icon.s),
                contentDescription = content.title
            )
            TextBodyLarge(content.title)
        }
    }
}
